import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { AppStoreModel } from "../app-store/app-store"
import { AutoFeederPondStoreModel } from "../auto-feeder-pond-store/auto-feeder-pond-store"
import { CharacterStoreModel } from "../character-store/character-store"
import { ChemicalMultiMeasurementModel } from "../chemical-multi-measurement-store/chemical-multi-measurement-store"
import { CycleStoreModel } from "../cycle-store/cycle-store"
import { CycleDiseaseStoreModel } from "../cycle-disease-store/cycle-disease-store"
import { DiseaseStoreModel } from "../disease-store/disease-store"
import { FarmStoreModel } from "../farm-store/farm-store"
import { FarmPondStoreModel } from "../farm-pond-store/farm-pond-store"
import { FastingStoreModel } from "../fasting-store/fasting-store"
import { FeedStoreModel } from "../feed-store/feed-store"
import { FeedingTrayControlStoreModel } from "../feeding-tray-control-store/feeding-tray-control-store"
import { FileStoreModel } from "../file-store/file-store"
import { HarvestStoreModel } from "../harvest-store/harvest-store"
import { HomeStoreModel } from "../home-store/home-store"
import { InitialSyncStoreModel } from "../initial-sync-store/initial-sync-store"
import { MicrobiologyMultiMeasurementModel } from "../microbiology-multi-measurement-store/microbiology-multi-measurement-store"
import { MortalityStoreModel } from "../mortality-store/mortality-store"
import { NewsStoreModel } from "../news-store/news-store"
import { PlanktonMultiMeasurementModel } from "../plankton-multi-measurement-store/plankton-multi-measurement-store"
import { PondStoreModel } from "../pond-store/pond-store"
import { SamplingStoreModel } from "../sampling-store/sampling-store"
import { ShrimpPriceStoreModel } from "../shrimp-price-store/shrimp-price-store"
import { TokenStoreModel } from "../token-store/token-store"
import { TreatmentStoreModel } from "../treatment-store/treatment-store"
import { UserStoreModel } from "../user-store/user-store"
import { WaterQualityMultiMeasurementModel } from "../water-quality-multi-measurement-store/water-quality-multi-measurement-store"
import { LoginModel } from "../login-store/login-store"
import { FarmShrimpPriceStoreModel } from "../farm-shrimp-price-store/farm-shrimp-price-store"
import { NotificationsStoreModel } from "../notifications-store/NotificationsStore"
import { SimulationStoreModel } from "../simulation-store/simulation-store"
import { CycleToDoStoreModel } from "../cycle-to-do-store/cycle-to-do-store"
import { WidgetStoreModel } from "../widget-store/widget-store"
import { ChemicalParameterStoreModel } from "../chemical-parameter-store/chemical-parameter-store"
import { ChemicalPredictionsStoreModel } from "../chemical-predictions-store/chemical-predictions-store"
import { OccupationStoreModel } from "../occupation-store/occupation-store"

const RootStoreProps = {
  appStore: types.optional(AppStoreModel, {} as any),
  autoFeederPondStore: types.optional(AutoFeederPondStoreModel, {} as any),
  characterStore: types.optional(CharacterStoreModel, {} as any),
  chemicalMultiMeasurementStore: types.optional(ChemicalMultiMeasurementModel, {} as any),
  cycleStore: types.optional(CycleStoreModel, {} as any),
  cycleDiseaseStore: types.optional(CycleDiseaseStoreModel, {} as any),
  diseaseStore: types.optional(DiseaseStoreModel, {} as any),
  farmStore: types.optional(FarmStoreModel, {} as any),
  farmPondStore: types.optional(FarmPondStoreModel, {} as any),
  farmShrimpPriceStore: types.optional(FarmShrimpPriceStoreModel, {} as any),
  fastingStore: types.optional(FastingStoreModel, {} as any),
  feedStore: types.optional(FeedStoreModel, {} as any),
  feedingTrayControlStore: types.optional(FeedingTrayControlStoreModel, {} as any),
  fileStore: types.optional(FileStoreModel, {} as any),
  harvestStore: types.optional(HarvestStoreModel, {} as any),
  homeStore: types.optional(HomeStoreModel, {} as any),
  initialSyncStore: types.optional(InitialSyncStoreModel, {} as any),
  microbiologyMultiMeasurementStore: types.optional(MicrobiologyMultiMeasurementModel, {} as any),
  mortalityStore: types.optional(MortalityStoreModel, {} as any),
  newsStore: types.optional(NewsStoreModel, {} as any),
  planktonMultiMeasurementStore: types.optional(PlanktonMultiMeasurementModel, {} as any),
  pondStore: types.optional(PondStoreModel, {} as any),
  samplingStore: types.optional(SamplingStoreModel, {} as any),
  shrimpPriceStore: types.optional(ShrimpPriceStoreModel, {} as any),
  tokenStore: types.optional(TokenStoreModel, {} as any),
  treatmentStore: types.optional(TreatmentStoreModel, {} as any),
  userStore: types.optional(UserStoreModel, {} as any),
  waterQualityMultiMeasurementStore: types.optional(WaterQualityMultiMeasurementModel, {} as any),
  loginStore: types.optional(LoginModel, {} as any),
  notificationsStore: types.optional(NotificationsStoreModel, {} as any),
  simulationStore: types.optional(SimulationStoreModel, {} as any),
  cycleToDoStore: types.optional(CycleToDoStoreModel, {} as any),
  widgetStore: types.optional(WidgetStoreModel, {} as any),
  chemicalParameterStore: types.optional(ChemicalParameterStoreModel, {} as any),
  chemicalPredictionsStore: types.optional(ChemicalPredictionsStoreModel, {} as any),
  occupationStore: types.optional(OccupationStoreModel, {} as any),
}

/**
 * A RootStore model.
 */
// prettier-ignore
export const RootStoreModel = types.model("RootStore")
  .props(RootStoreProps)
  .actions((self: any) => ({
    set(key: keyof typeof RootStoreProps, value: any) {
      self[key] = value;
    },
    async reset() {
      const locale = self.appStore.locale
      Object.keys(RootStoreProps).forEach((key: keyof typeof RootStoreProps) => {
        this.set(key, {});
      })
      self.appStore.setLocale(locale)
      await self.appStore.removeDatabase().catch();
    }
  }))

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
